module.exports = __webpack_public_path__ + "images/unigarant_small02fc5bf18bd40c32a53e222dc2055300.png";